import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import * as UserActions from "src/reducers/userReducer";
import { TicketList, Loading } from "src/components/structure";
interface IMobileTicketsProps {
  location: any;
  userActions: any;
  userState: any;
}

interface IMobileTicketsState {
  loading: boolean;
}

class MobileTickets extends Component<
  IMobileTicketsProps,
  IMobileTicketsState
> {
  constructor(props: IMobileTicketsProps) {
    super(props);

    this.state = {
      loading: false,
    };
  }

  render() {
    return this.state.loading ? <Loading /> : <TicketList department="mobile" />;
  }
}

const mapStateToProps = function map(s: any) {
  return {
    userState: s.userState,
  };
};

function mapDispatchToProps(dispatch: any) {
  return {
    userActions: bindActionCreators(UserActions, dispatch),
  };
}

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(MobileTickets) as any
);
